// FSSAIRegistration.jsx
import React from "react";

export default function FSSAIRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            FSSAI Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            FSSAI Registration for Food Businesses in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks provides expert assistance for FSSAI
            Registration, helping food businesses comply with the Food Safety
            and Standards Act and applicable FSSAI regulations.
          </p>
          <p className="text-gray-700">
            From identifying the correct category of registration and preparing
            application forms to organizing supporting documents and responding
            to department queries, the process is managed professionally so your
            food business can operate with regulatory confidence.
          </p>
        </div>

        {/* Right: Image (square for consistency) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3735842/pexels-photo-3735842.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Food safety compliance and FSSAI registration support"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for FSSAI Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps food business operators compile and
              structure core information and proofs needed for FSSAI
              Registration as per prevailing norms.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>PAN card of the applicant or business entity.</li>
                <li>
                  Identity and address proof of proprietor, partners, or
                  directors (such as Aadhaar, passport, voter ID, or driving
                  licence).
                </li>
                <li>
                  Business address proof or proof of premises (rent/lease
                  agreement, ownership papers, or recent utility bill).
                </li>
                <li>
                  Nature and scope of food business, including type of products
                  handled and operational details.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm offers focused food law compliance support, combining
              regulatory understanding with hands-on experience in FSSAI
              applications and ongoing obligations.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Strong Expertise in Food Law
                </h3>
                <p className="text-gray-700 text-sm">
                  Dedicated guidance on FSSAI requirements, helping align your
                  operations and documentation with the Food Safety and
                  Standards Act and related regulations.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Support in organizing application forms, identity and business
                  proofs, and food business details so filings are complete and
                  less prone to objections.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  End-to-End Professional Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance from initial assessment and documentation through
                  online filing, follow-up, and post-registration guidance for
                  practical compliance.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
